import { tailwind } from "@theme-ui/presets";
import { colors, fontWeights, typography } from "@greythr/shared-components";
import { theme2 } from "./index-v1";

const fonts = {
  body: '"Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  heading:
    '"Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  sans: '"Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
};

const theme = {
  colors,
  fontWeights,
  typography,
  breakpoints: ["300px", "600px", "900px", "1280px"],
  fonts,
  styles: {
    ...tailwind.styles,
    root: {
      fontFamily: "body",
      fontSize: "1rem",
      lineHeight: "normal",
    },
    h1: {
      mt: "4.5rem",
      mb: "1.5rem",
      ...typography.h1,
    },
    h2: {
      mt: ["3rem", "3rem", "4.5rem", "4.5rem"],
      mb: "1.5rem",
      ...typography.h2,
    },
    h3: {
      mt: "3rem",
      mb: "1.5rem",
      ...typography.h3,
    },
    h4: {
      mt: "3rem",
      mb: "1.5rem",
      ...typography.h4,
    },
    h5: {
      mt: "3rem",
      mb: "1.5rem",
      ...typography.h5,
    },
    h6: {
      mt: "3rem",
      mb: "1.5rem",
      ...typography.h6,
    },
    p: {
      mb: "1.5rem",
      mt: "1.5rem",
      ...typography.textMd400,
      whiteSpace: "pre-wrap",
      wordWrap: "break-word",
    },
    span: {
      mb: "1.5rem",
      mt: 0,
      ...typography.textMd400,
      whiteSpace: "pre-wrap",
      wordWrap: "break-word",
    },
    pre: {
      mb: "1.5rem",
      ...typography.textMd400,
      whiteSpace: "pre-wrap",
      wordWrap: "break-word",
    },
    a: {
      ...typography.textMd400,
      textDecoration: "none",
      color: colors.primaryMain,
      "&:hover": {
        textDecoration: "underline",
      },
    },
    ul: {
      pl: 3,
      mt: "0.25rem",
      mb: "0.25rem",
    },
    li: {
      mt: "0",
      mb: "0.25rem",
      ...typography.textMd400,
      p: {
        mt: 0,
        mb: 0,
      },
    },
    ol: {
      pl: 3,
      mt: "0",
      mb: "0.25rem",
    },
    hr: {
      m: 0,
      pb: 2,
    },
    blockquote: {
      borderColor: colors.primaryMain,
      borderStyle: "solid",
      borderWidth: 0,
      borderLeftWidth: 5,
      pt: 3,
      pb: 1,
      my: 3,
      pl: 4,
    },
    strong: {
      fontWeight: "bold",
    },
    b: {
      fontWeight: "bold",
    },
    em: {
      fontStyle: "italic",
    },
    i: {
      fontStyle: "italic",
    },
    code: {
      ...typography.textMd400,
      fontSize: "0.875rem",
    },
  },
};

export default { ...theme2, ...theme };
